/**
 * File ingestion resource types that identify rules for file processing
 * These resource types indicate that a rule is designed for file ingestion workflows
 */
export const FILE_INGESTION_RESOURCE_TYPES = [
  'OBJECTCREATED:PUT',
  'OBJECTCREATED:COPY',
  'OBJECTCREATED:COMPLETEMULTIPARTUPLOAD',
  // Add future file ingestion resource types here as they are introduced
] as const;

/**
 * Check if a rule's resource types indicate it's a file ingestion rule
 * @param resourceTypes - Array of resource types from a rule
 * @returns true if the rule is for file ingestion
 */
export const isFileIngestionRule = (resourceTypes?: string[]): boolean => {
  if (!resourceTypes || resourceTypes.length === 0) {
    return false;
  }

  return resourceTypes.some(resourceType =>
    FILE_INGESTION_RESOURCE_TYPES.includes(
      resourceType as (typeof FILE_INGESTION_RESOURCE_TYPES)[number],
    ),
  );
};

/**
 * Get the count of file ingestion resource types in a rule
 * @param resourceTypes - Array of resource types from a rule
 * @returns number of file ingestion resource types
 */
export const getFileIngestionResourceTypeCount = (
  resourceTypes?: string[],
): number => {
  if (!resourceTypes || resourceTypes.length === 0) {
    return 0;
  }

  return resourceTypes.filter(resourceType =>
    FILE_INGESTION_RESOURCE_TYPES.includes(
      resourceType as (typeof FILE_INGESTION_RESOURCE_TYPES)[number],
    ),
  ).length;
};
